import { Info } from "lucide-react";
import { HoverCard, HoverCardTrigger, HoverCardContent } from "@/components/ui/hover-card";
import { APP_VERSION, RELEASES } from "@/lib/releaseNotes";

export const VersionBadge = () => (
  <HoverCard openDelay={100} closeDelay={150}>
    <HoverCardTrigger asChild>
      <button
        type="button"
        className="flex items-center gap-1 text-[11px] font-mono font-semibold text-muted-foreground border rounded-full px-2.5 py-1 hover:bg-slate-50 hover:text-slate-800 transition-colors"
        data-testid="version-badge"
      >
        V{APP_VERSION}
        <Info className="w-3 h-3" />
      </button>
    </HoverCardTrigger>
    <HoverCardContent align="end" className="w-[420px] max-h-[70vh] overflow-y-auto" data-testid="version-release-notes">
      <div className="space-y-4">
        <div className="text-sm font-semibold">What's new in the portal</div>
        {RELEASES.map((r) => (
          <div key={r.version} className="space-y-1" data-testid={`release-${r.version}`}>
            <div className="flex items-center gap-2">
              <span className="text-xs font-mono font-bold">V{r.version}</span>
              {r.version === APP_VERSION && (
                <span className="text-[9px] font-semibold text-green-700 bg-green-50 border border-green-200 rounded-full px-1.5 py-px">
                  current
                </span>
              )}
            </div>
            <ul className="list-disc pl-4 space-y-0.5">
              {r.notes.map((n, i) => (
                <li key={i} className="text-[11px] leading-snug text-slate-600">
                  {n.split(/\*\*(.+?)\*\*/g).map((part, j) =>
                    j % 2 === 1 ? <strong key={j} className="text-slate-800">{part}</strong> : part
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </HoverCardContent>
  </HoverCard>
);
